import * as React from 'react';
import { SVGProps } from 'react';
import { SvgIcon } from '@mui/material';

export const SvgGivelifyGivingAppIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="70"
        viewBox="0 0 70 70"
        width="70"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_10604_5228)">
            <rect
                fill="#FDDDC7"
                fillOpacity="0.6"
                height="70"
                rx="35"
                width="70"
            />
            <g clipPath="url(#clip1_10604_5228)">
                <path
                    d="M41.0163 50.1685C38.6385 52.199 34.2679 52.199 32.8666 55.6467C32.2969 57.048 22.214 80.5643 22.214 80.5643H7.53809C7.53809 80.5643 15.4834 61.9525 18.7107 53.9338C22.0572 45.6193 20.3978 39.8414 22.5871 30.1038C24.2524 22.6964 21.1878 20.6679 23.6272 19.2051C26.0665 17.7423 28.6746 22.1327 27.2336 30.739C26.6719 34.0874 43.3961 48.14 41.0163 50.1685Z"
                    fill="#C14F2A"
                />
                <path
                    d="M41.2506 26.8011C39.6349 24.4232 46.8716 19.2388 48.4476 17.6708C50.9862 15.1461 52.8023 16.1981 53.2965 17.2818C53.8682 18.5322 52.6971 20.4575 50.4145 22.5892C49.2852 23.6412 42.8662 29.1789 41.2506 26.8011Z"
                    fill="#C14F2A"
                />
                <path
                    d="M44.5632 50.1685H28.9942C27.3071 50.1685 25.9395 48.801 25.9395 47.1139V12.1113C25.9395 10.4242 27.3071 9.05664 28.9942 9.05664H44.5632C46.2503 9.05664 47.6179 10.4242 47.6179 12.1113V47.1159C47.6159 48.803 46.2484 50.1685 44.5632 50.1685Z"
                    fill="#2F2B63"
                />
                <path
                    d="M22.5137 20.4694C23.256 20.1677 24.0262 20.6441 24.1889 21.7497C24.3517 22.8532 24.0658 23.9489 23.0853 24.3339C22.8432 24.3816 22.0671 20.6501 22.5137 20.4694Z"
                    fill="#DB823C"
                />
                <path
                    d="M44.3032 48.3564H29.2105C28.1725 48.3564 27.3289 47.4921 27.3289 46.424V12.5769C27.3289 11.5108 28.1705 10.6445 29.2105 10.6445H44.3032C45.3413 10.6445 46.1849 11.5088 46.1849 12.5769V46.424C46.1829 47.4921 45.3413 48.3564 44.3032 48.3564Z"
                    fill="#F7F8F8"
                />
                <path
                    d="M51.9945 39.1884C50.0493 37.0726 47.4829 39.9943 45.5973 41.1693C42.5586 43.0628 43.1679 45.0715 44.1087 45.8019C45.1944 46.6435 47.338 45.9448 49.9342 44.2081C51.2184 43.3486 53.9396 41.3043 51.9945 39.1884Z"
                    fill="#C14F2A"
                />
                <path
                    d="M43.9837 45.0655C43.6185 44.4463 43.5589 43.6067 44.9026 42.8504C46.2464 42.0942 46.4349 42.5825 46.8974 43.3625C47.3599 44.1446 47.2229 44.6229 46.2206 45.2144C45.2182 45.8098 44.3846 45.7443 43.9837 45.0655Z"
                    fill="#DB823C"
                />
                <path
                    d="M52.4132 33.4106C50.4681 31.2947 47.9017 34.2164 46.0161 35.3914C42.9773 37.285 43.5867 39.2936 44.5275 40.0241C45.6132 40.8656 47.7568 40.167 50.353 38.4302C51.6372 37.5708 54.3584 35.5264 52.4132 33.4106Z"
                    fill="#C14F2A"
                />
                <path
                    d="M44.4025 39.2877C44.0373 38.6684 43.9777 37.8288 45.3215 37.0726C46.6652 36.3164 46.8538 36.8047 47.3162 37.5847C47.7787 38.3667 47.6417 38.8451 46.6394 39.4366C45.637 40.03 44.8034 39.9665 44.4025 39.2877Z"
                    fill="#DB823C"
                />
                <path
                    d="M52.8301 27.6327C50.885 25.5169 48.3186 28.4386 46.433 29.6136C43.3942 31.5071 44.0035 33.5158 44.9443 34.2462C46.03 35.0878 48.1737 34.3891 50.7698 32.6524C52.054 31.7929 54.7772 29.7486 52.8301 27.6327Z"
                    fill="#C14F2A"
                />
                <path
                    d="M44.8212 33.5098C44.456 32.8906 44.3965 32.051 45.7402 31.2948C47.084 30.5385 47.2725 31.0268 47.735 31.8068C48.1975 32.5889 48.0605 33.0672 47.0582 33.6587C46.0558 34.2522 45.2222 34.1886 44.8212 33.5098Z"
                    fill="#DB823C"
                />
                <path
                    d="M37.4194 34.4804C37.0767 34.7168 36.633 34.7218 36.2862 34.4915C34.7965 33.5021 30.9016 30.6663 30.9016 28.063C30.9016 26.076 32.3303 24.5384 34.1768 24.5384C35.2192 24.5384 36.2013 25.0509 36.8561 25.8841C37.5109 25.0509 38.4931 24.5384 39.5355 24.5384C41.3819 24.5384 42.8106 26.076 42.8106 28.063C42.8106 30.5267 38.904 33.4561 37.4194 34.4804Z"
                    fill="#F85520"
                />
                <path
                    d="M16.8033 57.0557C16.6783 57.0101 16.5969 56.883 16.6128 56.7441C16.6306 56.5833 16.7775 56.4662 16.9403 56.4861L30.5542 58.0779C26.9557 56.0018 18.6254 52.3397 18.5321 52.2981C18.3832 52.2326 18.3157 52.0599 18.3812 51.909C18.4467 51.7602 18.6095 51.6867 18.7703 51.7582C19.203 51.9487 29.4209 56.4424 31.9873 58.2823C32.0965 58.3597 32.1401 58.5027 32.0905 58.6277C32.0429 58.7527 31.9158 58.8302 31.7809 58.8143L16.8708 57.0716C16.847 57.0676 16.8251 57.0636 16.8033 57.0557Z"
                    fill="#1F4161"
                />
                <path
                    d="M17.8116 54.3147C17.7123 54.2789 17.6369 54.1896 17.621 54.0785C17.5992 53.9177 17.7123 53.7688 17.8731 53.747C17.9545 53.7371 25.9871 52.6851 32.5113 56.8116C32.6482 56.8989 32.6899 57.0815 32.6026 57.2185C32.5153 57.3554 32.3326 57.3951 32.1957 57.3098C25.8621 53.2984 18.0319 54.3186 17.9545 54.3306C17.9029 54.3385 17.8553 54.3306 17.8116 54.3147Z"
                    fill="#1F4161"
                />
                <path
                    d="M23.788 58.4015C21.7833 57.6651 19.5642 56.6349 17.4127 55.1979C17.2777 55.1066 17.24 54.924 17.3313 54.789C17.4226 54.6541 17.6012 54.6203 17.7402 54.7077C24.042 58.9175 30.9314 59.5725 30.9989 59.5804C31.1596 59.5943 31.2807 59.7372 31.2668 59.9C31.2529 60.0628 31.11 60.1818 30.9473 60.168C30.8996 60.162 27.7695 59.8623 23.788 58.4015Z"
                    fill="#1F4161"
                />
                <path
                    d="M29.2482 68.0718C29.6492 66.867 28.9049 66.3708 29.2383 65.6304C30.4153 63.8897 29.796 63.4789 28.9505 63.0243C28.4702 62.7663 17.1884 57.5601 17.1884 57.5601C17.1884 57.5601 16.5036 57.0559 16.1662 57.5124C15.8288 57.969 15.5052 58.9614 15.277 59.4874C14.9356 60.2773 14.1158 59.8526 13.4767 61.2062C13.181 61.8354 6.6866 74.4669 3.51086 80.6378H24.7089C26.2908 76.291 28.8969 69.1237 29.2482 68.0718Z"
                    fill="#FED05D"
                />
            </g>
        </g>
        <defs>
            <clipPath id="clip0_10604_5228">
                <rect fill="white" height="70" rx="35" width="70" />
            </clipPath>
            <clipPath id="clip1_10604_5228">
                <rect
                    fill="white"
                    height="71.5811"
                    transform="translate(3.51086 9.05664)"
                    width="50"
                />
            </clipPath>
        </defs>
    </svg>
);

export const GivelifyGivingAppIcon = ({
    fontSize = 'inherit',
    color = 'inherit',
    ...props
}: React.ComponentProps<typeof SvgIcon>) => (
    <SvgIcon
        {...props}
        color={color}
        component={SvgGivelifyGivingAppIcon}
        fontSize={fontSize}
    />
);
